// Who a shift belongs to, in one place.
//
// The API serves three distinct names on every shift — `client_name`
// (`job.customer.name`), `venue_name` (the *address* label, `job.address.name`)
// and `billing_account_name` (`job.account.name`). They are three different
// entities, and picking a different one per surface is what GRAVY-10340 was:
// the calendar card titled on the venue label while the Shift Detail panel it
// opens, the queue tabs and Dashboard V1 all named the client. On a shared,
// reused or mislabelled address record the two disagree outright — Job 113073
// read "Cotton and Rye Restaurant" on the card and "Lansdowne Resort and Spa"
// in its own panel.
//
// So: the CLIENT is the identity, everywhere. The venue label is only a
// fallback for a job whose customer is missing, and the billing account is
// never used — internal labels like "Billing Account 2" say nothing about who
// owns the shift (GRAVY-10290).
export const shiftIdentity = (shift: {
  client_name?: string | null;
  venue_name?: string | null;
}): string => shift.client_name || shift.venue_name || 'Untitled shift';

export default shiftIdentity;
